module.exports = __webpack_public_path__ + "img/img-7.e3cf3e05.webp";